import { ReactNode } from 'react';
import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';

import { Breakpoint, Heading, Paragraph, tokens } from '@treams/treams-ui';

const BackdropContainer = styled.div`
	width: 100%;
	height: 100%;
	position: absolute;
	background-color: ${tokens.surface.sidebar};
`;

const Backdrop = styled.img`
	width: 100%;
	height: 100%;
	object-fit: cover;
	z-index: 0;
`;

const Content = styled(Flex)`
	position: relative;
	z-index: 1;
	background-image: linear-gradient(
		180deg,
		transparent 0%,
		${tokens.surface.overlay} 33%,
		${tokens.surface.sidebar} 100%
	);
`;

const Element = styled(Flex)`
	position: relative;
	min-height: 200px;
	@media screen and (min-width: ${Breakpoint.Medium}) {
		min-height: 300px;
	}
`;

export default function LearningCoverHeader(props: {
	imageUrl?: string | null;
	title: string;
	subtitle?: ReactNode;
	topAccessory?: ReactNode;
	children?: ReactNode;
}) {
	return (
		<Element flexDirection="column" justifyContent="space-between">
			<BackdropContainer>
				{props.imageUrl && <Backdrop src={props.imageUrl} alt="" />}
			</BackdropContainer>
			{props.topAccessory ?? <div />}
			<Content
				px={[2, 3, 4]}
				py={3}
				justifyContent="space-between"
				alignItems="center"
				flexWrap="wrap"
				flexGrow={0}
			>
				<Box mr={3}>
					<Heading style={{ color: tokens.text.inverse }}>{props.title}</Heading>
					{props.subtitle && (
						<Paragraph style={{ color: tokens.text.inverse }}>{props.subtitle}</Paragraph>
					)}
				</Box>
				{props.children}
			</Content>
		</Element>
	);
}
